/**
 * RM-359 (the product agent, reviewed by Kapil, 10/30): the guaranteed spend
 * guidance, right along with the ask of how much to guarantee (the request's
 * spend step; never group/private dining). The
 * approved wording, kept exactly; "ask RM" opens Ask RM for feedback with the
 * question already in it. RM AI's spend question, in the app and by text,
 * carries the same words (the replies table's `request.spend.guidance`, which a
 * server test pins this to).
 */
export const SPEND_GUIDANCE = 'Increase your chances by guaranteeing 2x+ the restaurant’s avg. spend. Want guidance on that amount - ask RM before submitting.'

const LINK = 'ask RM'

/** The sentence around its "ask RM" link: { before, link, after }. */
export const SPEND_GUIDANCE_PARTS = Object.freeze({
  before: SPEND_GUIDANCE.slice(0, SPEND_GUIDANCE.indexOf(LINK)),
  link: LINK,
  after: SPEND_GUIDANCE.slice(SPEND_GUIDANCE.indexOf(LINK) + LINK.length),
})

/** What Ask RM for feedback opens with when the member taps "ask RM" (theirs to change). */
export const SPEND_GUIDANCE_QUESTION = 'Guidance on my guaranteed spend amount'

/** Only a regular restaurant request carries it. */
export function showsSpendGuidance(reservation) {
  return !reservation?.reservationType || reservation.reservationType === 'general'
}

/**
 * RM AI's spend message links "ask RM" to /ask-rm/{request id} (Kapil 10/30): the request it opens
 * Ask RM for feedback on, or null for any other link.
 */
export function askRmReservationId(href) {
  const m = String(href || '').match(/^\/ask-rm\/([a-f0-9]{24})$/i)

  return m ? m[1] : null
}
